// get data and sort
export const FETCH_DATA_TO_SERVER = "FETCH_DATA_TO_SERVER";
//get data and filter
export const FETCH_DATA_IN_FILTER = "FETCH_DATA_IN_FILTER";
// get data and search
export const SEARCH = "SEARCH";
//get data and pagination
export const PAGINATION = "PAGINATION";
